import { GrimsbyNotification } from '../context/grimsbyNotifications';

const handleEditCourseNotification = async (
    dispatchPromise: Promise<boolean>,
    addNotification: (notification: GrimsbyNotification) => void,
): Promise<boolean> => {
    const isSuccessful = await dispatchPromise;

    addNotification({
        id: `update-course-${Date.now()}`,
        ...(isSuccessful
            ? {
                  type: 'success',
                  content: 'You have successfully edited this course.',
              }
            : {
                  type: 'error',
                  content: 'An error occurred while editing this course.',
              }),
    });

    return isSuccessful;
};

export default handleEditCourseNotification;
